import { render, staticRenderFns } from "./iteraMenu.vue?vue&type=template&id=123f8bae&scoped=true"
import script from "./iteraMenu.vue?vue&type=script&lang=js"
export * from "./iteraMenu.vue?vue&type=script&lang=js"
import style0 from "./iteraMenu.vue?vue&type=style&index=0&id=123f8bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f8bae",
  null
  
)

export default component.exports